import { API } from "../config/AppConfig";
import { 
    AUDITSHEET_USER, AUDIT_SHEET, AUDIT_SHEET_INDUSTRY, 
    AUDIT_SHEET_PROVIDER_DROPDOWN, AUDIT_UPLOAD, 
    GET_ALL_USER_API, GET_COMMENT, GET_BATCH_COMMENT, GET_COMMENT_FLAG,
    MANAGE_COMMENT, MONITOR_HOUR, POST_COMMENT, UPDATE_ACTIVITY, AUDIT_SHEET_ICD_CODES, AUDIT_SHEET_MODIFIER,
    AUDIT_SHEET_EXPORT, REBUTTAL_SUBMIT_VALIDATION,
    AUDIT_SHEET_RESPONSE_ISSUES_DROPDOWN, AUDIT_SHEET_DELTA, AUDIT_REPORT,
    BATCH_AUDIT_SHEET,
    GET_CLIENT_COMMENT_FLAG,
    GET_CLIENT_COMMENT,
    GET_BATCH_ALL_COMMENTS,
    GET_FILE_BY_BATCH,
    MY_CHARTS} from "../constants/Endpoints";

class AuditSheetRepository {
    async getProviderDropdown(chartId) {
        const response = await API.get(AUDIT_SHEET_PROVIDER_DROPDOWN, {
            pathParams: { chartId },
            queryParams: {view: "MANAGER"}
        });
        return response;
    }

    async getResponseAuditIssues() {
        const response = await API.get(AUDIT_SHEET_RESPONSE_ISSUES_DROPDOWN);
        return response;
    }

    async getAuditUpload(uploadId) {
        const response = await API.get(AUDIT_UPLOAD, {
            pathParams: { uploadId },
            queryParams: {view: "MANAGER"}
        });
        return response;
    }

    async getAuditSheet(uploadId) {
        const response = await API.get(AUDIT_SHEET, {
            pathParams: { uploadId },
            queryParams: {view: "MANAGER"}
        });
        return response;
    }

    async createAuditSheet(payload, uploadId) {
        const response = await API.post(AUDIT_SHEET, {
            pathParams: { uploadId },
            body: payload,
            queryParams: {view: "MANAGER"}
        });
        return response;
    }

    async updateAuditSheet(payload, uploadId) {
        const response = await API.put(AUDIT_SHEET, {
            pathParams: { uploadId },
            body: payload,
            queryParams: {view: "MANAGER"}
        });
        return response;
    }

    async createAuditSheetDelta(payload, uploadId) {
        const response = await API.post(AUDIT_SHEET_DELTA, {
            queryParams: {view: "MANAGER"},
            pathParams: { uploadId },
            body: payload
        });
        return response;
    }

    async auditHourMonitor(uploadId) {
        const response = await API.post(MONITOR_HOUR, {
            pathParams: { uploadId },
            queryParams: {view: "MANAGER"}
        });
        return response;
    }

    async recentAuditImageUpload(uploadId, data) {
        const response = await API.put(MONITOR_HOUR, {
            pathParams: { uploadId },
            queryParams: {view: "MANAGER"},
            body: data
        });
        return response;
    }

    async getIndustryCodes() {
        const response = await API.get(AUDIT_SHEET_INDUSTRY);
        return response;
    }

    async getICDCodes() {
        const response = await API.get(AUDIT_SHEET_ICD_CODES);
        return response;
    }

    async getModifiers() {
        const response = await API.get(AUDIT_SHEET_MODIFIER);
        return response;
    }

    async getUsers() {
        const response = await API.get(AUDITSHEET_USER);
        return response;
    }

    async updateActivity(data) {
        const response = await API.post(UPDATE_ACTIVITY, {
            body: data
        });
        return response;
    }

    // async getComments(uploadId, queryParams) {
    //     const response = await API.get(GET_COMMENT, {
    //         queryParams,
    //         pathParams: { uploadId }
    //     });
    //     return response;
    // }

    async getComments(params) {
        const { uploadId, batchId, ...queryParams } = params
        const response = await API.get(uploadId ? GET_COMMENT : GET_CLIENT_COMMENT, {
            queryParams,
            pathParams: { uploadId, batchId }
        });
        return response;
    }

    async getBatchComments(batchId) {
        const response = await API.get(GET_BATCH_COMMENT, {
            pathParams: { batchId },
            queryParams: { view: "MANAGER", reverse: true, page: 1 }
        });
        return response;
    }

    async getAllUsers() {
        const response = await API.get(GET_ALL_USER_API);
        return response;
    }

    async getBatchAllComments(batchId, queryParams) {
        const response = await API.get(GET_BATCH_ALL_COMMENTS, {
            pathParams: { batchId },
            queryParams,
        });
        return response;
    }

    async getCommentFlag({ uploadId, batchId }) {
        const response = await API.get(uploadId ? GET_COMMENT_FLAG : GET_CLIENT_COMMENT_FLAG, {
            pathParams: { uploadId, batchId },
            queryParams: {view: "MANAGER"}
        });
        return response;
    }

    async deleteComment(commentId) {
        const response = await API.delete(MANAGE_COMMENT, {
            pathParams: { commentId },
        });
        return response;
    }

    async editComment(commentId, payload) {
        const response = await API.put(MANAGE_COMMENT, {
            pathParams: { commentId },
            body: payload
        });
        return response;
    }

    async postComment(data) {
        const response = await API.post(POST_COMMENT, {
            body: data
        });
        return response;
    }

    async getRebuttalSubmitValidation(uploadId) {
        const response = await API.get(REBUTTAL_SUBMIT_VALIDATION, {
            pathParams: { uploadId },
            queryParams: { view: 'MANAGER' },
        });
        return response;
    }

    async getAuditSheetDataForExport(params) {
        const response = await API.get(AUDIT_SHEET_EXPORT, {
            queryParams: params
        });
        return response;
    }

    async getAuditReport(queryParams){
        const response = await API.get(AUDIT_REPORT, {
            queryParams,
        });
        return response;
    }

    async getBatchAuditSheet(batchId, queryParams) {
        const response = await API.get(BATCH_AUDIT_SHEET, {
            pathParams: { batchId },
            queryParams: queryParams || {}
        });
        return response;
    }

    /**
     * Charts that belong to a batch, along with the auditor assigned to each of
     * them. The dashboard listing is keyed by batch, so this returns that single
     * batch row with its charts in `subRows`.
     *
     * `batch_id` is an exact filter, not `search`: search matches batch_id with
     * icontains, so "123" also matches 1123 and 1230, and with the default
     * -batch_id ordering the batch we want can be pushed off the first page.
     * Search also narrows subRows to the charts that matched it. The rows come
     * back scoped to the caller's role, so an auditor still only sees their own
     * charts of the batch.
     */
    async getBatchCharts(batchId) {
        const response = await API.get(MY_CHARTS, {
            queryParams: { batch_id: batchId, page: 1, size: 1 },
        });
        return response;
    }

    async getFileObjectByBatchId(batchId, queryParams = null) {
        const response = await API.get(GET_FILE_BY_BATCH, {
            pathParams: { batchId },
            queryParams: queryParams || {}
        });
        return response;
    }

}

const auditSheetRepository = new AuditSheetRepository();
export default auditSheetRepository;